import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '⚡',
  title: 'Freedom From Planning Stress',
  description: 'Open the system. Choose the volume or age group. Run the session. The heavy planning is already done for you.'
}, {
  emoji: '👑',
  title: 'Authority And Confidence',
  description: "With a proven, progressive structure behind you, you'll arrive on the court knowing exactly what to run and how to unlock your players' potential."
}, {
  emoji: '📈',
  title: 'Real Player Development',
  description: 'Structured pathways help your players improve faster, make sharper decisions, and grow more consistently through the entire season.'
}, {
  emoji: '😌',
  title: 'No More Practice Panic',
  description: 'Stop wondering what to run tomorrow. Basketball Ready gives you a complete coaching roadmap for 365 days.'
}];
export function Benefits() {
  return <section className="relative bg-navy-950 py-12 md:py-20" data-id="element-3">
      <div className="container mx-auto px-4" data-id="element-4">
        <div className="mx-auto mb-8 max-w-4xl text-center md:mb-16" data-id="element-5">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-5 font-anton text-3xl uppercase tracking-normal text-white md:mb-6 md:text-5xl md:tracking-wide" data-id="element-6">
            WHAT WILL CHANGE?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base font-medium leading-7 text-gray-400 md:text-xl" data-id="element-7">
            What will change in your coaching life?
            <br data-id="element-8" />
            Real benefits from the very first week.
          </motion.p>
        </div>

        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 md:grid-cols-2 md:gap-8" data-id="element-9">
          {benefits.map((benefit, index) => <motion.article key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 sm:gap-6" data-id="element-10">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl border border-navy-700 bg-navy-900 text-xl shadow-lg sm:h-16 sm:w-16 sm:text-3xl" data-id="element-11">
                {benefit.emoji}
              </div>
              <div data-id="element-12">
                <h3 className="mb-2 font-oswald text-xl uppercase tracking-normal text-white md:text-2xl md:tracking-wide" data-id="element-13">
                  {benefit.title}
                </h3>
                <p className="leading-relaxed text-gray-400" data-id="element-14">
                  {benefit.description}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}